










































import { MANAGE_SPACE_OPTIONS } from "@/resources/constants/sidebarMenu";
import { Component, Vue } from "vue-property-decorator";
import SuperSpaceCardComponent from "./superSpaceCard.component.vue";
@Component({
  name: "super-space-list-component",
  components: { SuperSpaceCardComponent },
})
export default class SuperSpaceListComponent extends Vue {
  search = "";
  loading = false;
  searchTimeOut = null;
  lastScroll = 0;
  async mounted(): Promise<void> {
    await this.$store.dispatch("SuperSpaceStore/setSuperSpacesAction", []);
    await this.$store.dispatch(
      "SuperSpaceStore/setSuperSpacesAvailablePageAction",
      1
    );
    await this.$store.dispatch(
      "SuperSpaceStore/setLastPageSuperSpacesAction",
      2
    );
  }
  get superSpaces() {
    const superSpaces = this.$store.getters["SuperSpaceStore/getSuperSpaces"]
      .filter((a) =>
        this.search !== ""
          ? a.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a
      )
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    return superSpaces;
  }
  get disabledLoader(): boolean {
    const lastPage =
      this.$store.getters["SuperSpaceStore/getLastPageSuperSpaces"];
    const page =
      this.$store.getters["SuperSpaceStore/getSuperSpacesAvailablePage"];
    return page > lastPage;
  }
  async getSuperSpaces(): Promise<void> {
    if (!this.disabledLoader)
      await this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
        pagination: true,
        callback: () => {
          // do nothing
        },
        callbackError: (error) => {
          this.loading = false;
        },
      });
  }

  onSearch(): void {
    const lengthSuperSpaces = this.$store.getters[
      "SuperSpaceStore/getSuperSpaces"
    ].filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    ).length;

    if (lengthSuperSpaces < 5) {
      this.loading = true;
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.loading = true;
      this.searchTimeOut = setTimeout(async () => {
        await this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
          name: this.search,
          pagination: false,
          callback: () => {
            this.loading = false;
          },
          callbackError: (error) => {
            this.loading = false;
          },
        });
      }, 1000);
    }
  }
}
